export default "__VITE_ASSET__rUSbNzkQ__"